
import React from "react";

export default function Footer() {
  const quickLinks = [
    { name: "선원 소개", href: "#" },
    { name: "수행/법문", href: "#" },
    { name: "순례성지", href: "#" },
    { name: "소식", href: "#" },
    { name: "자료실", href: "#" },
    { name: "참여/후원", href: "#" },
  ];

  const socialLinks = [
    { 
      icon: "ri-youtube-line", 
      href: "https://www.youtube.com/@cheonchukseonwon", 
      color: "hover:text-red-500",
      label: "천축선원 유튜브"
    },
    { 
      icon: "ri-facebook-circle-line", 
      href: "https://www.facebook.com/cheonchukseonwon", 
      color: "hover:text-blue-600",
      label: "천축선원 페이스북"
    },
    { 
      icon: "ri-instagram-line", 
      href: "https://www.instagram.com/cheonchukseonwon", 
      color: "hover:text-pink-600",
      label: "천축선원 인스타그램"
    },
    { 
      icon: "ri-chat-3-line", 
      href: "https://open.kakao.com/o/cheonchukseonwon", 
      color: "hover:text-yellow-500",
      label: "천축선원 카카오톡"
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/bb60b64d4d14d0ba531f646d8a4266d5/715edbe496612a699d95c6d9bea4226e.png" 
                alt="천축선원 로고" 
                className="h-12 w-auto object-contain"
              />
              <div>
                <h3
                  className="text-2xl font-bold text-white"
                  style={{ fontFamily: "'Noto Serif KR', serif" }}
                >
                  천축선원
                </h3>
                <p className="text-sm text-amber-400">Cheonchuk Seonwon</p>
              </div>
            </div>

            <p
              className="text-gray-400 mb-6 leading-relaxed"
              style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
            >
              부처님께서 금강경을 설하신 인도 스라바스티 기원정사 인근에
              위치한 한국 조사선 수행 도량입니다. 1999년 창건 이래 30년간 전통
              화두 참선 수행을 이어오고 있습니다.
            </p>

            {/* Social Links */}
            <div className="flex gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center ${social.color} transition-colors cursor-pointer`}
                  title={social.label}
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-lg font-bold text-white mb-6"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              바로가기
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="text-lg font-bold text-white mb-6"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              연락처
            </h4>
            <ul className="space-y-4">
              {/* Address */}
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-amber-400 text-xl mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm font-semibold text-white mb-1">주소</p>
                  <a
                    href="https://maps.google.com/maps?q=korean+temple+shravasti,+Khargupur,+Uttar+Pradesh+271805"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    Near Jetavana Gate<br />
                    Khargupur, Uttar Pradesh 271805<br />
                    India
                  </a>
                </div>
              </li>

              {/* Email */}
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-amber-400 text-xl mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm font-semibold text-white mb-1">이메일</p>
                  <a
                    href="mailto:vardanshakya237@gmail.com"
                    className="text-sm hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    vardanshakya237@gmail.com
                  </a>
                </div>
              </li>

              {/* Phone */}
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-amber-400 text-xl mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm font-semibold text-white mb-1">전화</p>
                  <div className="text-sm space-y-1">
                    <a
                      href="tel:+918923139035"
                      className="flex items-center gap-2 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      <span className="text-base">🇮🇳</span>
                      <span>+91-892-313-9035</span>
                      <span className="text-xs text-gray-400">
                        (총괄 메니저)
                      </span>
                    </a>
                    <a
                      href="tel:+917991755124"
                      className="flex items-center gap-2 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      <span className="text-base">🇮🇳</span>
                      <span>+91-799-175-5124</span>
                      <span className="text-xs text-gray-400">
                        (주지스님)
                      </span>
                    </a>
                    <a
                      href="tel:+8201065081961"
                      className="flex items-center gap-2 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      <span className="text-base">🇰🇷</span>
                      <span>82 10-6508 1961</span>
                      <span className="text-xs text-gray-400">
                        (총무 적조행)
                      </span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2025 Cheonchuk Seonwon. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="hover:text-amber-400 transition-colors cursor-pointer">
                개인정보처리방침
              </a>
              <a href="#" className="hover:text-amber-400 transition-colors cursor-pointer">
                이용약관
              </a>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-amber-400 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
